import React from "react"
import { Field, reduxForm } from "redux-form"
import Button from "@mui/material/Button"
import CircularProgress from "@mui/material/CircularProgress"

import BasicField from "../components/BasicField"

const normalizeConfirmCode = value => value ? value.trim() : value

const validate = values => {
  const errors = {}

  if (!values.confirmCode) {
    errors.confirmCode = "Required"
  }
  else if (values.confirmCode.length < 4) {
    errors.confirmCode = "Code too short"
  }

  return errors
}

const ConfirmAccountForm = ({ handleSubmit, invalid, pristine, submitting }) => {
  return (
    <form onSubmit={ handleSubmit }>
      <p>Please don't close or refresh this page until you've entered the confirmation code!</p>

      <p>A confirmation code has been sent to your email address - enter it below:</p>
      <div className="field">
        <Field name="confirmCode" label="Confirmation Code" type="text" normalize={normalizeConfirmCode} component={BasicField}/>
      </div>
      <div>
        <Button
          type="submit"
          className="fullWidthButton"
          variant="contained"
          color="primary"
          size="large"
          disabled={invalid || pristine || submitting}>
            {submitting ? <CircularProgress size={24} /> : "Confirm your registration"}
        </Button>
      </div>
    </form>
  )
}

export default reduxForm({ form: "confirmAccount", validate })(ConfirmAccountForm)